// File: frontend/src/components/common/EmailInput.js

import React, { useState } from 'react';
import styles from './EmailInput.module.css';

const EmailInput = ({
  value = '',
  onChange,
  label,
  placeholder,
  required = false,
  error = null,
  disabled = false
}) => {
  const [isFocused, setIsFocused] = useState(false);
  
  const handleEmailChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };
  
  return (
    <div className={styles.emailInputContainer}>
      {label && (
        <label className={styles.label}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}
      
      <div className={`${styles.inputGroup} ${error ? styles.hasError : ''} ${isFocused ? styles.focused : ''}`}>
        <input
          type="email"
          name="email" // ✅ Help browsers identify
          className={styles.emailInput}
          placeholder={placeholder || 'you@example.com'}
          value={value}
          onChange={handleEmailChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          disabled={disabled}
          required={required}
          autoComplete="email" // ✅ Enable autofill
        />
      </div>
      
      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};

export default EmailInput;